import Dropzone from "react-dropzone";
import {
  Typography,
  Paper,
  Box,
  Grid,
  TextField,
  Link,
  IconButton,
  Tooltip,
  Stack,
} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import DocumentScannerIcon from "@mui/icons-material/DocumentScanner";
import DrawIcon from "@mui/icons-material/Draw";

export default function EditFiles(props) {
  return (
    <div>
      <Paper elevation={6}>
        <div className="FeatureFiles">
          <Dropzone
            onDrop={(acceptedFiles) => props.getAcceptedFiles(acceptedFiles)}

            // onDrop={(acceptedFiles) => props.getAcceptedFiles(acceptedFiles)}
          >
            {({ getRootProps, getInputProps }) => (
              <section>
                <div {...getRootProps({ className: "dropzone" })}>
                  <input className="Inputmargin" {...getInputProps()} />

                  <Typography
                    color="primary.dark"
                    align="center"
                    style={{ paddingTop: 15, paddingBottom: 15 }}
                  >
                    Drag 'n' drop files here, or click to select files
                  </Typography>
                </div>
              </section>
            )}
          </Dropzone>
        </div>
      </Paper>

      <Box style={{ marginTop: 30 }} sx={{ flexGrow: 1 }}>
        <Grid container spacing={2}>
          {props.editFiles
            .filter((f) => f.deleted === false)
            .map((f, idx) => (
              <Grid key={idx} size={{ xs: 12, sm: 6 }}>
                {f.file.startsWith("data:image/") ||
                [
                  ".jpg",
                  "jpeg",
                  ".png",
                  ".gif",
                  ".bmp",
                  "webp",
                  ".svg",
                ].includes(
                  f.file.split("?alt=media")[0].slice(-4).toLowerCase(),
                ) ? (
                  <Paper elevation={6} style={{ marginTop: 30, padding: 16 }}>
                    <div style={{ position: "relative" }}>
                      <Tooltip
                        style={{
                          position: "absolute",
                          // margin: 6,
                          // margin: 6,
                          top: 6,
                          right: 6,
                          backgroundColor: "lightgray",
                        }}
                        title="Delete File"
                      >
                        <IconButton
                          aria-label="Remove"
                          color="primary"
                          onClick={() => props.onRemoveEditFile(f.id)}
                        >
                          <ClearIcon />
                        </IconButton>
                      </Tooltip>
                      <Tooltip
                        style={{
                          position: "absolute",
                          margin: 6,
                          bottom: 6,
                          // left: 6,
                          backgroundColor: "lightgray",
                        }}
                        title="Scan Image for Text"
                      >
                        <IconButton
                          aria-label="Scan Image for Text"
                          color="primary"
                          onClick={() => props.onScanPic(f.id)}
                        >
                          <DocumentScannerIcon />
                        </IconButton>
                      </Tooltip>
                      <Tooltip
                        style={{
                          position: "absolute",
                          margin: 6,

                          backgroundColor: "lightgray",
                        }}
                        title="Draw on Image"
                      >
                        <IconButton
                          aria-label="Draw on Image"
                          color="primary"
                          onClick={() => props.onDrawPic(f.id)}
                        >
                          <DrawIcon />
                        </IconButton>
                      </Tooltip>
                      <img
                        alt={f.name}
                        src={f.file}
                        style={{ maxHeight: 300, maxWidth: "100%" }}
                      />
                    </div>
                    <br />
                    <TextField
                      style={{ marginTop: 8 }}
                      autoFocus={props.editFiles.length === idx + 1}
                      fullWidth
                      id={f.id}
                      label="Comment"
                      value={f.comment}
                      placeholder="file comment here"
                      onChange={props.onEditFileCommentChange}
                    />
                  </Paper>
                ) : (
                  <Paper elevation={6} style={{ marginTop: 30, padding: 16 }}>
                    <Stack
                      direction="row"
                      spacing={1}
                      sx={{
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <Link href={f.file} variant="body2">
                        {f.name}
                      </Link>
                      <Tooltip
                        style={{
                          margin: 8,
                          backgroundColor: "lightgray",
                        }}
                        title="Delete File"
                      >
                        <IconButton
                          aria-label="Remove"
                          color="primary"
                          onClick={() => props.onRemoveEditFile(f.id)}
                        >
                          <ClearIcon />
                        </IconButton>
                      </Tooltip>
                    </Stack>
                    <TextField
                      style={{ marginTop: 8 }}
                      fullWidth
                      autoFocus={props.editFiles.length === idx + 1}
                      id={f.id}
                      label="Comment"
                      value={f.comment}
                      placeholder="file comment here"
                      onChange={props.onEditFileCommentChange}
                    />
                  </Paper>
                )}
              </Grid>
            ))}
        </Grid>
      </Box>
    </div>
  );
}
